// Sugestões de especialidades médicas comuns (autocomplete — não é lista fechada).

export const ESPECIALIDADES_SUGERIDAS = [
  'Alergia e Imunologia', 'Anestesiologia', 'Angiologia', 'Cardiologia',
  'Cirurgia Geral', 'Cirurgia Plástica', 'Clínica Médica', 'Dermatologia',
  'Endocrinologia e Metabologia', 'Gastroenterologia', 'Geriatria',
  'Ginecologia e Obstetrícia', 'Hematologia e Hemoterapia', 'Infectologia',
  'Mastologia', 'Medicina de Família e Comunidade', 'Medicina do Trabalho',
  'Nefrologia', 'Neurologia', 'Nutrologia', 'Oftalmologia', 'Oncologia Clínica',
  'Ortopedia e Traumatologia', 'Otorrinolaringologia', 'Pediatria',
  'Pneumologia', 'Psiquiatria', 'Radiologia e Diagnóstico por Imagem',
  'Reumatologia', 'Urologia',
]
